import React from 'react';
import { connect } from 'react-redux';
import { IbanElement } from '@stripe/react-stripe-js';
import { languageSelector } from '../../redux/application/selector';
import ErrorList from '../ErrorList';

const translate = trKey => window.VULOG_TRANSLATE(trKey);

// Custom styling can be passed as options when creating an Element.
const IBAN_STYLE = {
    base: {
        color: '#32325d',
        fontSize: '16px',
        width: '100%',
        '::placeholder': {
            color: '#aab7c4',
        },
        ':-webkit-autofill': {
            color: '#32325d',
        },
    },
    invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
        ':-webkit-autofill': {
            color: '#fa755a',
        },
    },
};

const IbanForm = ({ onSubmit, disabled, locale, errors, setName, setEmail, handleOnChangeIban }) => {
    const placeholderCountry = locale.slice(-2);

    const IBAN_ELEMENT_OPTIONS = {
        supportedCountries: ['SEPA'],
        // Elements can use a placeholder as an example IBAN that reflects
        // the IBAN format of your customer's country. If you know your
        // customer's country, we recommend that you pass it to the Element as the
        // placeholderCountry.
        placeholderCountry,
        style: IBAN_STYLE,
    };

    return (
        <>
            {window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={errors} />}
            <form onSubmit={onSubmit}>
                <label htmlFor={'accountHolderName'} className={'blue small mt-3 mb-0 isRequired'}>
                    {translate('sepaName')}
                </label>
                <input
                    type="text"
                    name="accountHolderName"
                    className="form-control"
                    id={'accountHolderName'}
                    onChange={e => setName(e.target.value)}
                />

                <label htmlFor={'email'} className={'blue small mt-3 mb-0 isRequired'}>
                    {translate('sepaEmailAddress')}
                </label>
                <input
                    type="text"
                    name="email"
                    className="form-control"
                    id={'email'}
                    onChange={e => setEmail(e.target.value)}
                />

                <label htmlFor={'email'} className={'blue small mt-3 mb-0 isRequired'}>
                    {translate('IBAN')}
                </label>
                <IbanElement options={IBAN_ELEMENT_OPTIONS} onChange={e => handleOnChangeIban(e)} />

                {/* Display mandate acceptance text. */}
                <div className="alert alert-info mt-4">
                    <small>{translate('sepaInfo')}</small>
                </div>

                <div className="flex-row mt-4 mb-2rem">
                    <button className="btn btn-primary btn-block" type="submit" disabled={disabled}>
                        {translate('sepaBtnLabel')}
                    </button>
                </div>
            </form>
            {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={errors} />}
        </>
    );
};

const mapStateToProps = state => ({
    locale: languageSelector(state),
});

export default connect(mapStateToProps, null)(IbanForm);
